import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PcsDashboardComponent } from '../shared/components/pcs-dashboard/pcs-dashboard.component';
import { AuthenticationGuard } from 'src/app/authentication.guard';
import { OrganizationRouteResolverComponent } from './organization-route-resolver.component';
import { NotificationsListComponent } from '../shared/views/notifications-list/notifications-list.component';
import { HomeComponent } from '../shared/components/home/home.component';
import { ProvidersListComponent } from '../shared/views/providers-list/providers-list.component';
import { ProductMbrListComponent } from '../shared/views/product-mbr-list/product-mbr-list.component';
import { ProductMbrDetailComponent } from '../shared/views/product-mbr-detail/product-mbr-detail.component';
import { ProviderOrganizationListComponent } from '../admin/components/provider-organization-list/provider-organization-list.component';
import { ProductsListComponent } from '../admin/components/products-list/products-list.component';
import { ConsultantOrganizationListComponent } from '../admin/components/consultant-organization-list/consultant-organization-list.component';
import { ConsultantListComponent } from '../shared/views/consultant-list/consultant-list.component';
import { ProviderBulkUploadComponent } from '../shared/views/provider-bulk-upload/provider-bulk-upload.component';

const routes: Routes = [
  {
    path: '', component: HomeComponent, children: [
      { path: 'dashboard', component: PcsDashboardComponent },
      { path: 'product-mbr-list', component: ProductMbrListComponent },
      { path: 'product-mbr/:productId/:lenderId', component: ProductMbrDetailComponent },
      { path: 'products-list', component: ProductsListComponent },
      { path: 'notifications-list', component: NotificationsListComponent },
      { path: 'organization-home', component: OrganizationRouteResolverComponent},
      { path: 'organization', component: ProvidersListComponent },
      { path: 'organization/:id', component: ProvidersListComponent },
      { path: 'bulk-upload', component: ProviderBulkUploadComponent, canActivate: [AuthenticationGuard] },
      { path: 'organization-list', component: ProviderOrganizationListComponent },
      { path: 'consultant-organization-list', component: ConsultantListComponent, canActivate: [AuthenticationGuard] },
      { path: 'consultant-organization-list/:id', component: ConsultantListComponent, canActivate: [AuthenticationGuard] },
      {
        path: 'form-submission',
        loadChildren: () =>
          import(
            '../shared/views/form-submission/form-submission.route'
          ).then((mod) => mod.FORM_SUBMISSION_ROUTES),
        canActivate: [AuthenticationGuard],

      },
      {
        path: 'search',
        loadChildren: () =>
          import(
            '../shared/views/general-search/general-search.route'
          ).then((mod) => mod.GENERAL_SEARCH_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'form-consolidation',
        loadChildren: () =>
          import(
            '../shared/views/form-consolidation/form-consolidation.route'
          ).then((mod) => mod.FORM_CONSOLIDATION_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'marketing-material',
        loadChildren: () =>
          import(
            '../shared/views/marketing-material/marketing-material.route'
          ).then((mod) => mod.MARKETING_MATERIAL_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'lender-organization',
        loadChildren: () =>
          import(
            '../shared/views/lender-organizations/lender-organizations.route'
          ).then((mod) => mod.LENDER_ORGANIZATION_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'lender-approval',
        loadChildren: () =>
          import(
            '../shared/views/lender-approval/lender-approval.route'
          ).then((mod) => mod.LENDER_APPROVAL_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'forms-management',
        loadChildren: () =>
          import(
            '../shared/views/forms-management/forms-management.route'
          ).then((mod) => mod.FORMS_MANAGEMENT_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'marketing-material-inventory',
        loadChildren: () =>
          import(
            '../shared/views/marketing-material-inventory/marketing-material-inventory.route'
          ).then((mod) => mod.MARKETING_MATERIAL_INVENTORY_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'corporate-document',
        loadChildren: () =>
          import(
            '../shared/views/corporate-document/corporate-document.route'
          ).then((mod) => mod.CORPORATE_DOCUMENT_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'miscellaneous-document',
        loadChildren: () =>
          import(
            '../shared/views/miscellaneous-document/miscellaneous-document.route'
          ).then((mod) => mod.MISCELLANEOUS_DOCUMENT_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'provider-approval',
        loadChildren: () =>
          import(
            '../shared/views/provider-approval/provider-approval.route'
          ).then((mod) => mod.PROVIDER_APPROVAL_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      { path: '', redirectTo: '/provider/dashboard', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProviderRoutingModule { }
